import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Modal, Input, Select, Toast, Popconfirm, Form } from '@douyinfe/semi-ui';
import { IconEdit, IconDelete, IconPlus, IconSearch, IconEyeOpened, IconTick } from '@douyinfe/semi-icons';
import request from '../../utils/request';
import ImageSelector from '../../components/ImageSelector';

const Templates = () => {
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [pagination, setPagination] = useState({ currentPage: 1, pageSize: 10, total: 0 });

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [searchKey, setSearchKey] = useState('');
    const [searchCat, setSearchCat] = useState('');
    const [formApi, setFormApi] = useState(null);
    const [showQrCodeModal, setShowQrCodeModal] = useState(false);
    const [qrCodeImage, setQrCodeImage] = useState('');

    const handlePreview = async (uid) => {
        try {
            const response = await request.get(`/go/sp/weixin/xcx_qrcode/`, {
                params: {
                    //uid: public_uid,
                    path: `/pages/basic/ms/ms?uid=${uid}`,
                    env_version: 'release',
                    is_hyaline: 1,
                    width: 430
                },
                responseType: 'arraybuffer' // Important for image data
            });

            if (response.byteLength > 0) {
                const base64Image = btoa(
                    new Uint8Array(response).reduce(
                        (data, byte) => data + String.fromCharCode(byte),
                        ''
                    )
                );
                setQrCodeImage(`data:image/png;base64,${base64Image}`);
                setShowQrCodeModal(true);
            } else {
                Toast.error('获取二维码失败');
            }
        } catch (error) {
            console.error('获取二维码失败:', error);
            Toast.error('获取二维码失败');
        }
    };

    const handleApply = async (uid) => {
        Modal.confirm({
            title: '确认应用模板',
            content: '应用此模板将覆盖您当前的数据，请确认是否继续？',
            onOk: async () => {
                try {
                    const response = await request.post('/go/sp/admin/use_kmjb_tpls/', {
                        uid: uid,
                        //public_uid: '' 
                    });
                    if (response.errno === 0) {
                        Toast.success('应用模板成功');
                    } else {
                        Toast.error(response.errstr || '应用模板失败');
                    }
                } catch (error) {
                    console.error('应用模板失败:', error);
                    Toast.error('应用模板失败');
                }
            },
            onCancel: () => {
                Toast.info('已取消应用模板');
            },
        });
    };

    const fetchList = async (page = 1, limit = 10) => {
        setLoading(true);
        try {
            const response = await request.get('/go/sp/admin/list_kmjb_tpls/', {
                params: {
                    page: page - 1,
                    limit,
                    key: searchKey,
                    cat: searchCat
                }
            });
            if (response.errno === 0) {
                setDataSource(response.list || []);
                setPagination(prev => ({
                    ...prev,
                    currentPage: page,
                    total: response.total_cnt
                }));
            } else {
                Toast.error(response.errstr || '获取模板列表失败');
            }
        } catch (error) {
            console.error('获取模板列表失败:', error);
            Toast.error('获取模板列表失败');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchList();
    }, []);



    const formatTimestamp = (timestamp) => {
        if (!timestamp) return '-';
        const date = new Date(parseInt(timestamp));
        return date.toLocaleString();
    };

    const columns = [
        {
            title: '模板ID',
            dataIndex: 'uid',
            width: 200,
        },
        {
            title: '标题',
            dataIndex: 'title',
            width: 200,
        },
        {
            title: '分类',
            dataIndex: 'cat',
            width: 150,
        },
        {
            title: '图片',
            dataIndex: 'image',
            width: 150,
            render: (text) => text ? <img src={text} alt="模板图片" style={{ width: 80, height: 80 }} /> : '-'
        },
        {
            title: '点击量',
            dataIndex: 'click_cnt',
            width: 100,
        },
        {
            title: '点赞量',
            dataIndex: 'like_cnt',
            width: 100,
        },
        {
            title: '创建时间',
            dataIndex: 'create_time',
            width: 180,
            render: (text) => formatTimestamp(text)
        },
        {
            title: '操作',
            dataIndex: 'operate',
            width: 250,
            render: (text, record) => (
                <Space>

                    <Button
                        icon={<IconEyeOpened />}
                        size="small"
                        onClick={() => handlePreview(record.uid)}
                    >预览</Button>
                    <Button
                        icon={<IconTick />}
                        size="small"
                        type="primary"
                        onClick={() => handleApply(record.uid)}
                    >应用</Button>

                </Space>
            ),
        },
    ];

    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(selectedRowKeys);
        },
    };

    const onSearch = () => {
        fetchList(1, pagination.pageSize);
    };

    const handlePageChange = (page, pageSize) => {
        fetchList(page, pageSize);
    };

    return (
        <div className="templates-container" style={{ padding: '20px' }}>
            <Space align="baseline" style={{ marginBottom: '20px' }}>
                <Input
                    prefix={<IconSearch />}
                    placeholder="搜索标题"
                    value={searchKey}
                    onChange={v => setSearchKey(v)}
                    onEnterPress={onSearch}
                />
                <Input
                    placeholder="搜索分类"
                    value={searchCat}
                    onChange={v => setSearchCat(v)}
                    onEnterPress={onSearch}
                />
                <Button icon={<IconSearch />} onClick={onSearch}>搜索</Button>

            </Space>

            <Table
                columns={columns}
                dataSource={dataSource}
                pagination={pagination}
                loading={loading}
                rowSelection={rowSelection}
                onPageChange={handlePageChange}
                rowKey="uid"
            />



            <Modal
                title="预览二维码"
                visible={showQrCodeModal}
                onCancel={() => setShowQrCodeModal(false)}
                footer={null}
                centered
            >
                {qrCodeImage ? (
                    <img src={qrCodeImage} alt="小程序二维码" style={{ width: '100%' }} />
                ) : (
                    <p>正在生成二维码...</p>
                )}
            </Modal>
        </div>
    );
};

export default Templates;